var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { memo } from 'react';
import { styled } from '@web/theme';
import { Icon } from '@web/utils';
export var ButtonContent = memo(function (_a) {
    var children = _a.children, icon = _a.icon;
    return (React.createElement(React.Fragment, null,
        icon && React.createElement(Icon, { icon: icon }),
        children && React.createElement(BBody, null, children)));
});
export var BBody = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  font-size: inherit;\n  \n  &:not(:first-child) {\n    margin-left: .5em;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  font-size: inherit;\n  \n  &:not(:first-child) {\n    margin-left: .5em;\n  }\n"])));
var templateObject_1;
